import React from 'react'
import Nav from '../components/WebDevelopment/Nav'
import ParticleBackground from '../components/glopal/ParticleBackground'
import MyLink from '../components/WebDevelopment/MyLink'

const WebDevelopment = () => {
    return (
        <div>
            <Nav />
            <div className="gradientFull">
                <ParticleBackground />
                <MyLink />
            </div>
        </div>
    )
}

export default WebDevelopment